import { Header, HeaderActionBack, HeaderActionCustomerService } from "@/components/Header";
import { Layout } from "@/components/Layout";
import { useCryptoPayments } from "@/stores/CryptoTradingStore";
import { Detail } from "./Detail";
import './index.scss';
const title = 'VipPay';
export const PageProfessionDetail = () => {
  const store = useCryptoPayments();
  return <Layout scrollable backgroundImage={false} header={<Header title="超级商家规则与义务" leftActions={<HeaderActionBack />} rightActions={<HeaderActionCustomerService />} />} data-sentry-element="Layout" data-sentry-component="PageProfessionDetail" data-sentry-source-file="index.tsx">
      <div className="profession_detail">
      <Detail title={title} hideAlipayWechatProfessionMerchant={store.hideAlipayWechatProfessionMerchant} data-sentry-element="Detail" data-sentry-source-file="index.tsx" />
      </div>
     
    </Layout>;
};